import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 col-md-6 col-sm-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Plan Manager"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 sub-title" }, [
    /*#__PURE__*/_createElementVNode("small", null, "Manage the application plan options")
  ])
], -1)
const _hoisted_5 = { class: "col-12 col-md-6 col-sm-12 d-lg-flex d-md-flex d-sm-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" New Plan ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_10 = { class: "w-100 bg-white p-5" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = { class: "text-capitalize" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-trash text-primary",
  style: {}
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AddPlanModal = _resolveComponent("AddPlanModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add_plan = true)),
            class: "btn btn-new-design-primary w-180-px w-100 w-md-40 w-sm-100 w-lg-30 mt-3 mt-lg-0 mt-md-0 mt-sm-3"
          }, _hoisted_8)
        ])
      ])
    ]),
    _createVNode(_component_Card, { "with-header": false }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  row: "5"
                })
              ])
            ]))
          : (_openBlock(), _createBlock(_component_DataTable, {
              key: 1,
              "table-data": _ctx.table.items,
              "table-header": _ctx.tableHeaders,
              "row-class": "table-hover"
            }, {
              "cell-name": _withCtx(({ row: item }) => [
                _createElementVNode("strong", _hoisted_11, _toDisplayString(item.name), 1)
              ]),
              "cell-formatted_monthly_price": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.formatted_monthly_price), 1)
              ]),
              "cell-formatted_annual_price": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item.formatted_annual_price), 1)
              ]),
              "cell-formatted_has_free_trial": _withCtx(({ row: item }) => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.formatted_has_free_trial), 1)
              ]),
              "cell-action": _withCtx(({ row: item }) => [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.confirmDeletePlan(item)),
                  class: "btn btn-icon"
                }, _hoisted_15, 8, _hoisted_13)
              ]),
              _: 1
            }, 8, ["table-data", "table-header"]))
      ]),
      _: 1
    }),
    _createVNode(_component_AddPlanModal, {
      "initial-values": _ctx.plan,
      type: _ctx.formType,
      modelValue: _ctx.add_plan,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.add_plan) = $event)),
      onOnUpdate: _ctx.handleUpdatePlan,
      onOnSaved: _ctx.handleStorePlan,
      loading: _ctx.saving
    }, null, 8, ["initial-values", "type", "modelValue", "onOnUpdate", "onOnSaved", "loading"])
  ]))
}